/*=========================================================================================
  File Name: moduleTodoGetters.js
  Description: Map Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	getGroupById: (state) => (groupId) => state.groups.find((g) => g.id == groupId),
	getSelectedGroup: (state) => state.selectedGroup,
};
